module.exports = __webpack_public_path__ + "static/media/returns_zoom.454bd1ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/returns_zoom.png
// module id = 103
// module chunks = 0